import { c as _c } from "react/compiler-runtime";
type Props = {
  className?: string;
  hideBanner?: boolean;
};
export default function SelfScheduleSkeleton(t0) {
  const $ = _c(9);
  const {
    className,
    hideBanner
  } = t0;
  const t1 = `relative h-full !motion-opacity-in-0 motion-duration-1000 ${className ?? ""}`;
  let t2;
  if ($[0] !== hideBanner) {
    t2 = !hideBanner && <div className="h-32 w-full md:mx-auto" />;
    $[0] = hideBanner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-between"><div className="h-8 w-24 animate-pulse rounded bg-muted" /></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-2 mt-6"><div className="mb-2 h-7 w-40 animate-pulse rounded bg-muted" /></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-6"><div className="grid grid-cols-2 gap-4 md:grid-cols-3">{Array.from({
          length: 6
        }).map(_temp)}</div></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mx-auto max-w-3xl px-6 pb-12">{t3}{t4}{t5}<div className="mt-8 flex items-center justify-center pb-8"><div className="h-4 w-56 animate-pulse rounded bg-muted" /></div></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t1 || $[7] !== t2) {
    t7 = <div className={t1}>{t2}{t6}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}
function _temp(_, i) {
  return <div key={`card-${i}`} className="rounded-xl   p-4 pb-14 shadow-sm"><div className="flex items-start justify-between"><div className="h-5 w-3/4 animate-pulse rounded bg-muted" /></div><div className="mt-2 h-4 w-14 animate-pulse rounded bg-muted" /></div>;
}